import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
export var CardImage = function (props) {
    return (React.createElement("img", { style: props.style, className: classNames('k-card-image', props.className), src: props.src }));
};
CardImage.propTypes = {
    className: PropTypes.string,
    src: PropTypes.string
};
CardImage.defaultProps = {
    src: ''
};
//# sourceMappingURL=CardImage.js.map